import React from "react";
import { ISpinnerProps } from "../../../helpers/uiInterfaces/common";
import styles from "./Spinner.module.scss";
import watchdogLogo from "@images/watchdog-image.png";

const Spinner: React.FC<ISpinnerProps> = (props) => {
  const { fullscreen } = props;

  function renderSpinner() {
    const watchdogLogoAttributes = {
      src: watchdogLogo,
      className: styles.spinnerImage,
    };

    if (fullscreen === true) {
      return (
        <div className={styles.spinnerFullScreenContainer}>
          <div className={styles.spinner}>
            <img {...watchdogLogoAttributes} alt="watchdog" />
          </div>
        </div>
      );
    }

    return (
      <div className={styles.spinnerContainer}>
        <div className={styles.spinner}>
          <img {...watchdogLogoAttributes} alt="watchdog" />
        </div>
      </div>
    );
  }

  return <div className={styles.spinnerMain}>{renderSpinner()}</div>;
};

export default Spinner;
